import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../../utils/AuthContext';
import { Link } from 'react-router-dom';

export const AIGoalsOptimization = () => {
    const { subscription } = useAuth();
    const isPremium = subscription === 'premium';

    if (!isPremium) {
        return (
            <Card className="card-one">
                <Card.Header>
                    <Card.Title as="h6">AI Goals Optimization</Card.Title>
                </Card.Header>
                <Card.Body className="text-center py-4">
                    <i className="ri-rocket-line fs-48 text-primary mb-3"></i>
                    <h5>Unlock AI-Powered Goals Optimization</h5>
                    <p className="text-muted mb-4">
                        Upgrade to Premium to get personalized goal recommendations, smart progress tracking, 
                        and AI-driven insights to achieve your financial goals faster.
                    </p>
                    <Link to="/dashboard/pricing">
                        <Button variant="primary">
                            Upgrade to Premium
                            <i className="ri-arrow-right-line ms-2"></i>
                        </Button>
                    </Link>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card className="card-one">
            <Card.Header>
                <Card.Title as="h6">AI Goals Optimization</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="mb-4">
                    <h6 className="fw-semibold">Goal Health Score</h6>
                    <div className="d-flex align-items-center">
                        <div className="circle-progress">
                            <h1>85</h1>
                            <span>/ 100</span>
                        </div>
                        <div className="ms-4">
                            <h5 className="text-success mb-1">Good Progress!</h5>
                            <p className="text-muted mb-0">
                                Your goals are well-structured and on track.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mb-4">
                    <h6 className="fw-semibold">AI Recommendations</h6>
                    <Alert variant="info" className="d-flex align-items-center">
                        <i className="ri-lightbulb-line fs-24 me-2"></i>
                        <div>
                            Consider increasing your monthly savings by 10% to reach your retirement goal faster.
                        </div>
                    </Alert>
                    <Alert variant="warning" className="d-flex align-items-center">
                        <i className="ri-timer-line fs-24 me-2"></i>
                        <div>
                            Your education goal might need adjustment - current progress is behind schedule.
                        </div>
                    </Alert>
                </div>

                <div>
                    <h6 className="fw-semibold">Smart Actions</h6>
                    <div className="d-grid gap-2">
                        <Button variant="outline-primary" className="text-start">
                            <i className="ri-calendar-check-line me-2"></i>
                            Generate Monthly Milestone Plan
                        </Button>
                        <Button variant="outline-primary" className="text-start">
                            <i className="ri-funds-line me-2"></i>
                            Optimize Goal Allocation
                        </Button>
                        <Button variant="outline-primary" className="text-start">
                            <i className="ri-line-chart-line me-2"></i>
                            Get Detailed Progress Analysis
                        </Button>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}; 